export default "__VITE_ASSET__3fbace4b__"